import type {
    PlaylistItemRequest,
    SendItemResultRequest,
    SendStateRequest,
    SendTrackingRequest,
} from './index';
import type { Playlist, PlaylistItem, PlaylistItemContent } from '../playlist';

export class LocalClient {
    url: string;
    token: string;

    constructor(url: string, token: string) {
        this.url = url;
        this.token = token;
    }

    async fetchPlaylist(): Promise<Playlist> {
        let playlist: PlaylistItem[] = [
            {
                content_id: '1',
                content_type: 'live',
                playback_sec: 20,
                content_url: null,
                enable_audio: false,
            },
            {
                content_id: '101',
                content_type: 'live_recording',
                playback_sec: 20,
                content_url: null,
                enable_audio: false,
            },
            {
                content_id: '2',
                content_type: 'live',
                playback_sec: 20,
                content_url: null,
                enable_audio: false,
            },
            {
                content_id: '201',
                content_type: 'live_recording',
                playback_sec: 20,
                content_url: null,
                enable_audio: false,
            },
            {
                content_id: '106',
                content_type: 'live_recording',
                playback_sec: 20,
                content_url: null,
                enable_audio: false,
            },
            {
                content_id: '3',
                content_type: 'live',
                playback_sec: 20,
                content_url: null,
                enable_audio: false,
            },
            {
                content_id: '4',
                content_type: 'live',
                playback_sec: 20,
                content_url: null,
                enable_audio: false,
            },
            {
                content_id: '203',
                content_type: 'live_recording',
                playback_sec: 20,
                content_url: null,
                enable_audio: false,
            },
            {
                content_id: '204',
                content_type: 'live_recording',
                playback_sec: 20,
                content_url: null,
                enable_audio: false,
            },
            {
                content_id: '5',
                content_type: 'live',
                playback_sec: 20,
                content_url: null,
                enable_audio: false,
            },
        ];

        return {
            name: 'local playlist',
            description: '',
            resolution: 720,
            template_name: 'default',
            map_detail: 'feature',
            display_safearea: false,
            logo: {
                image: 'https://livespotting.fra1.cdn.digitaloceanspaces.com/playout/c61cba4f-68a3-488e-b2e4-ffb8e182794f-0bc52970-b3d4-4615-a690-8f183edc11ac_logo.jpg',
                position: 'top-right',
                width: '15vw',
                margin: '3% 5% 0 0',
            },
            playlist: playlist,
            audio_url: '',
        };
    }

    async getContent(props: PlaylistItemRequest): Promise<PlaylistItemContent> {
        const { content_id, content_type, index, playback_sec } = props;

        let source = {
            src: `${this.url}/memfs/live_${content_id}.m3u8?token=${this.token}`,
            type: 'application/x-mpegURL',
        };

        if (
            content_type == 'live_recording' ||
            content_type == 'video_importer'
        ) {
            source = {
                src: `${this.url}/vod_${content_id}.mp4`,
                type: 'video/mp4',
            };
        }

        let item = {
            id: content_id,
            type: '',
            index: index,
            metadata: {
                camera_id: content_id,
                index: index,
                location_name: `camera_${content_id}`,
                location_banner: 'http://localhost:8080/logo.png',
                location_city: 'Bielefeld ' + content_id,
                location_county: 'Nowhere',
                location_region: 'Keine Ahnung',
                location_country: 'Deutschland',
                logo_background_color: '#ffffff',
                location_website: 'www.example.com',
                location_weather_icon36: 'd_2.svg',
                location_weather_tmax36: 28,
                location_weather_tmin36: 20,
                location_weather_icon60: 'd_2.svg',
                location_weather_tmax60: 29,
                location_weather_tmin60: 21,
                location_weather_icon84: 'd_2.svg',
                location_weather_tmax84: 30,
                location_weather_tmin84: 22,
                locstion_today: 'Montag',
                location_today: 'Montag',
                location_weather_day1: 'Mo',
                location_weather_day2: 'Di',
                location_weather_day3: 'Mi',
                longitude: 8.3094181,
                latitude: 54.8947311,
                country_code: 'DE',
            },
            source,
            playback_sec: playback_sec,
            enable_audio: false,
        };

        return item;
    }

    async sendState(req: SendStateRequest): Promise<any> {
        console.log('sendState', req);

        return null;
    }

    async sendItemResult(req: SendItemResultRequest): Promise<any> {
        console.log('sendItemResult', req);
        return null;
    }

    async sendTracking(req: SendTrackingRequest): Promise<any> {
        console.log('sendTracking', req);
        return null;
    }
}
